export default {
  'entityName': 'template',
  pagination: {
    'itemsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  filterStorage: {},
  'fields': [

    {
      slim: true,
      value: 'name',
      text: 'Name',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required',
      ]
    },

    
    {
      semifull: true,
      value: 'tag',
      text: 'Tag',
      type: 'combobox',
      multiple:true,
      chips:true,
      loadRemote:false,
      items: ['Banner', 'Banner Generator', 'Comunicati', 'Dicono di noi', 'Focus on', 'Intervista', 'Landing Page'],
      'table': {
        'sortable': true,
        'filter': true
      },
      default: null,
    },

    // {
    //   full: true,
    //   value: 'content',
    //   text: 'Content',
    //   type: 'textarea',
    //   rows:10,
    // },

    {
      full: true,
      "value": "content",
      "text": "Content",
      "type": "component",
      "name": "app-codeeditor",
      "props" : {
        wrap_code:true
      }
      // "readonly": item => { return item.id ? true : false },
      // "return_object": true,
      // render: (item) => {
      //     return item.country.name + " (" + item.country.code + ")" 
      // },
    },

  

  ],
  actions: [
    {
      "value": "update",
      "text": "Edit",
      "icon": "mdi-pencil",
      "color": "primary",
  },'delete'
  ]
}
